var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-avatar',_vm._g({attrs:{"tile":"","color":_vm.value}},on),[_vm._v("   ")])]}}])},[_c('v-color-picker',{attrs:{"value":_vm.value},on:{"input":function (v) { return _vm.$emit('input', v.hex || v); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }